import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const SecurityTrends = ({ trendsData }) => {
  const [chartData, setChartData] = useState({
    series: [
      { name: 'Critical', data: [] },
      { name: 'High', data: [] },
      { name: 'Medium', data: [] },
      { name: 'Low', data: [] }
    ],
    options: {
      chart: {
        type: 'line',
        height: 350,
        toolbar: { show: true },
      },
      xaxis: {
        categories: [],
        labels: {
          style: { fontSize: '12px' },
          rotate: -45,
        },
        title: {
          text: 'Scan Date',
          style: { fontSize: '14px', fontWeight: 'bold' },
        },
      },
      yaxis: {
        title: {
          text: 'Security Findings',
          style: { fontSize: '14px', fontWeight: 'bold', color: '#333' },
        },
      },
      colors: ['#dc3545', '#fd7e14', '#ffc107', '#28a745'],
      markers: { size: 5 },
      stroke: { width: 2, curve: 'smooth' },
      legend: { position: 'bottom' },
    },
  });

  useEffect(() => {
    if (trendsData && Array.isArray(trendsData) && trendsData.length > 0) {
      console.log('SecurityTrends - Raw trendsData:', trendsData);
      const sortedData = [...trendsData].sort((a, b) => 
        new Date(a.scanDate) - new Date(b.scanDate)
      );

      const categories = sortedData.map(item => {
        const date = new Date(item.scanDate);
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('default', { month: 'short' });
        return `${day}-${month}`;
      });

      const criticalData = [];
      const highData = [];
      const mediumData = [];
      const lowData = [];

      sortedData.forEach(item => {
        let severityDist = {};
        if (typeof item.severityDistribution === 'string') {
          severityDist = JSON.parse(item.severityDistribution || '{}');
        } else if (item.severityDistribution?.S) {
          severityDist = JSON.parse(item.severityDistribution.S || '{}');
        } else if (typeof item.severityDistribution === 'object') {
          severityDist = item.severityDistribution;
        }

        criticalData.push(parseInt(severityDist.Critical) || 0);
        highData.push(parseInt(severityDist.High) || 0);
        mediumData.push(parseInt(severityDist.Medium) || 0);
        lowData.push(parseInt(severityDist.Low) || 0);
      });

      console.log('SecurityTrends - Processed data:', { categories, criticalData, highData, mediumData, lowData });
      
      setChartData(prev => ({
        ...prev,
        options: {
          ...prev.options,
          xaxis: { ...prev.options.xaxis, categories },
        },
        series: [
          { name: 'Critical', data: criticalData },
          { name: 'High', data: highData },
          { name: 'Medium', data: mediumData },
          { name: 'Low', data: lowData }
        ],
      }));
    }
  }, [trendsData]);

  return (
    <div className="rounded shadow p-3 pb-0">
      <h5 className="fw-bold text-muted mb-3" style={{ color: '#333' }}>
        Security Trends Over Time
      </h5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="line"
        height="350"
      />
    </div>
  );
};

export default SecurityTrends;